import { useRef, useState } from "react";
import ComicCard from "@/components/base/ComicCard";
import { comics } from "@/mocks/comics";

export default function ScrollableComicRow() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 10);
    }
  };

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
      setTimeout(checkScroll, 400);
    }
  };

  const hotComics = comics.slice(0, 8);

  return (
    <section className="py-14 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900">
              热门推荐
              <span className="text-primary-500 ml-2">· 大家都在看</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-1.5">精选最受欢迎的韩国漫画，每日更新</p>
          </div>
          <span className="hidden md:inline-block px-4 py-1.5 rounded-full bg-foreground-900 text-background-50 text-xs font-medium">
            实时热度
          </span>
        </div>

        <div className="relative">
          {canScrollLeft && (
            <button
              onClick={() => scroll("left")}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>
          )}

          <div
            ref={scrollRef}
            onScroll={checkScroll}
            className="flex gap-5 overflow-x-auto scrollbar-hide pb-2"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {hotComics.map((comic) => (
              <ComicCard
                key={comic.id}
                {...comic}
                variant="compact"
              />
            ))}
            <div className="flex-shrink-0 w-[80px] md:w-[120px] flex items-center justify-center">
              <div className="text-center">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-2">
                  <i className="ri-arrow-right-line text-lg"></i>
                </div>
                <p className="text-xs text-foreground-500 whitespace-nowrap">查看更多</p>
              </div>
            </div>
          </div>

          {canScrollRight && (
            <button
              onClick={() => scroll("right")}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          )}
        </div>
      </div>
    </section>
  );
}